import { Layout as AntdLayout } from "antd";
import type { LayoutProps as AntdLayoutProps } from "antd";

export type LayoutProps = AntdLayoutProps;

/**
 * Layout component - application layout wrapper
 * Re-exports Ant Design Layout with static subcomponents (Header, Content, Sider, Footer)
 */
const Layout = AntdLayout;

export default Layout;

